import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'stupa-ott-layout',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './ott-layout.component.html',
  styleUrl: './ott-layout.component.scss'
})
export class OttLayoutComponent {

}
